<template>
    <div v-if="form">
        <input type="file" @change="getFile">
        <img :src="form.image" style="width: 50px" />
        
        <div style="padding: 1rem 0">
            <h5>Название услуги</h5>
            <label for="name-ru">RU</label>
            <b-form-input type="text" v-model="form.name.ru" name="name-ru" />
            <label for="name-ua">UA</label>
            <b-form-input type="text" v-model="form.name.ua" name="name-ua" />
            <label for="name-ua">EN</label>
            <b-form-input type="text" v-model="form.name.en" name="name-en" />
        </div>
        <div>
            <h5>Заголовок</h5>
            <label for="header-ru">RU</label>
            <b-form-input type="text" v-model="form.header.ru" name="header-ru" />
            <label for="name-ua">UA</label>
            <b-form-input type="text" v-model="form.header.ua" name="header-ua" />
            <label for="name-ua">EN</label>
            <b-form-input type="text" v-model="form.header.en" name="header-en" />
        </div>
        <div>
            <h5>Текст</h5>
            <label for="text-ru">RU</label>
            <b-form-textarea type="text" v-model="form.text.ru" name="text-ru" />
            <label for="text-ua">UA</label>
            <b-form-textarea type="text" v-model="form.text.ua" name="text-ua" />
            <label for="name-ua">EN</label>
            <b-form-textarea type="text" v-model="form.text.en" name="text-en" />
        </div>


        <div style="margin-top: 1rem">
            <button class="btn btn-info" style="width: 100%" @click="save">save</button>
        </div>
    </div>
</template>

<script>
import { store } from '../../store';

import Data from '../../API.js'
export default {
    props: ['editData'],
    data() {
        return {
            form: null,
            file: null
        }
    },
    created() {
        this.form = this.editData;
        console.log('form>>', this.form);
    },
    methods: {
        getFile(event) {
            if (event.target.files && event.target.files.length) {
                const selectedFile = event.target.files[0];
                const reader = new FileReader();

                reader.onload = (event) => {
                    this.form.image = event.target.result;
                };

                reader.readAsDataURL(selectedFile);
            }
        },
        save() {
            this.form.token = localStorage.getItem('token');
            for (let key in this.form) {
                if (key == 'name') {
                    this.form.service_name = this.form[key];
                    delete this.form[key];
                }
                if (key == 'image') {
                    this.form.img = this.form[key];
                    delete this.form[key];
                }
            }
            
            console.log('FORM', this.form)
            Data.editService({ ...this.form })
                .then(json => {
                    if (json.data.status == 'done') {
                        this.$emit('saved')
                    }
                    else alert('произошла ошибка')
                })
        }
    },
    computed: {
        service() {
            return store.getStart.service_data
        }
    }
}
</script>

<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/service/editService.vue